import React, { useState } from "react";
import logo from "../../../assets/logo.png";
import {
  Theme,
  Button,
  Drawer,
  makeStyles,
} from "@material-ui/core";
import { UserType } from "../../../data/enums";
import BurgerMenuIcon from "./BurgerMenuIcon";
import CloseIcon from "@material-ui/icons/Close";
import { useHistory } from "react-router-dom";


const useStyles = makeStyles((theme: Theme) => ({
  drawer: {
    "& .MuiBackdrop-root": {
      top: "60px",
    },
  },
}));

type LandingHeaderOptionProps = {
  redirect: (p: string) => void;
  classes?: string;
};

function LandingHeaderOptions({ redirect, classes }: LandingHeaderOptionProps) {

  return (
    <div className={`landing-header-options ${classes}`}>
      {/* <p onClick={() => redirect(`/signup/?user=${UserType.Nutritionist}`)}>
        Para nutricionistas
      </p>
      <p onClick={() => redirect(`/signup/?user=${UserType.Company}`)}>
        Para empresas
      </p> */}
      <p onClick={() => redirect('/consulta-nutricional')}>
        Consulta nutricional
      </p>
      <p onClick={() => redirect('/platos-semanales')}>
        Platos semanales
      </p>
      <p onClick={() => redirect(`/signup/?user=${UserType.EndUser}`)}>
        Comprar Kit
      </p>
      <Button
        color="primary"
        variant="outlined"
        onClick={() => redirect(`/login`)}
      >
        Iniciar Sesión
      </Button>
    </div>
  );
}

type LandingHeaderProps = {
  redirect: (p: string) => void;
};

function LandingHeader({ redirect }: LandingHeaderProps) {
  const [open, setOpen] = useState(false);
  const classes = useStyles();

  const history = useHistory();

  function goToHome() {
    history.push('/');
  }

  return (
    <>
      <div className="landing-header">
        <img className="landing-header-img" src={logo} alt="Logo de Mr. Gen" onClick={goToHome}/>
        <LandingHeaderOptions
          redirect={redirect}
          classes="landing-header-options-desktop"
        />
        {!open ? (
          <div className="landing-header-burger" onClick={() => setOpen(true)}>
            <BurgerMenuIcon />
          </div>
        ) : (
          <div className="landing-header-close" onClick={() => setOpen(false)}>
            <CloseIcon color="primary" fontSize="large" />
          </div>
        )}
      </div>
      
      <Drawer
        open={open}
        anchor="top"
        onClose={() => setOpen(false)}
        classes={{
          paperAnchorTop: "landing-drawer-paper",
          root: classes.drawer,
        }}
        elevation={0}
      >
        <LandingHeaderOptions
          redirect={redirect}
          classes="landing-header-options-mobile"
        />
      </Drawer>
    </>
  );
}

export default LandingHeader;
